import React from "react";
import Logo from "./../../assets/images/logo_light.png";
import TikTok from "./../../assets/images/TiktokLogo.png";
import Twitter from "./../../assets/images/TwitterLogo.png";
import Instagram from "./../../assets/images/InstagramLogo.png";
import Facebook from "./../../assets/images/facebookLogo.png";
import Verified from "./../../assets/images/verified.png";
import "./footer.css";
const Footer = () => {
  return (
    <div className="footer">
      <div className="footer_header">
        <img src={Logo} alt="" />
        <p className="footer_description">Blend Your Beauty, Mix with Mixy</p>

        <div className="socail_icons">
          <button>
            <img src={TikTok} alt="" />
          </button>
          <button>
            <img src={Twitter} alt="" />
          </button>
          <button>
            <img src={Instagram} alt="" />
          </button>
          <button>
            <img src={Facebook} alt="" />
          </button>
        </div>
      </div>

      <div className="footer_bottom">
        <div className="footer_left">
          <p className="footer_text">AOD New York, <br />New York NY, 10035</p>
          <a href="mailto:info@mixybeauty.com" className="footer_text">info@mixybeauty.com</a>
        </div>
        <div className="footer_right">
          <img src={Verified} alt="" />
          <p className="footer_text">© 2023 MIxyBeauty® All Rights Reserved.</p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
